import { isExpirationTip } from '../utils/contextMenu/sharingTipContextMenuItem/isExpirationTip';
import { observer } from 'mobx-react';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import { ControlIcons } from 'owa-control-icons';
import { LinkActionStatus, setRefreshStatus, SharingLinkInfo } from 'owa-link-data';
import { SharingTipInfo } from 'owa-sharing-data';
import strings from 'owa-strings/owa-mail-strings';
import * as React from 'react';

const styles = require('./SharingTipOverlay.scss');
const classNames = require('classnames');

export interface SharingTipsOverlayProps {
    sharingLinkInfo: SharingLinkInfo;
    sharingIssue: SharingTipInfo;
}

@observer
export class SharingTipOverlay extends React.Component<SharingTipsOverlayProps, {}> {
    render() {
        //For now we only support overlays for expiration, but this should be a switch statement when we support actions for other tips.
        const refreshStatus: LinkActionStatus = this.props.sharingLinkInfo.linkActionStatus;

        if (
            !isExpirationTip(this.props.sharingIssue.id) ||
            refreshStatus === LinkActionStatus.none ||
            refreshStatus === LinkActionStatus.refreshFailed
        ) {
            return null;
        }

        if (refreshStatus === LinkActionStatus.refreshing) {
            return (
                <div className={styles.overlay}>
                    <Spinner className={styles.spinner} size={SpinnerSize.medium} />
                    {strings.RefreshLinkInProgressText}
                </div>
            );
        } else if (refreshStatus === LinkActionStatus.refreshSucceeded) {
            // when the refresh was successful we show an overlay indicating this.
            // after 4 seconds the overlay fades away. Since the link will still expire we reset
            // the status to none.
            setTimeout(
                () => setRefreshStatus(this.props.sharingLinkInfo.linkId, LinkActionStatus.none),
                4000
            );
            return (
                <div className={classNames(styles.overlay, styles.fadeOut)}>
                    <Icon iconName={ControlIcons.CheckMark} className={styles.check} />
                    {strings.LinkSuccessfullyRefreshedText}
                </div>
            );
        }

        return null;
    }
}
